import { render } from "./ai-text-box.vue?vue&type=template&id=04462960"
import script from "./ai-text-box.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-text-box.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-text-box.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04462960"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04462960', __exports__)) {
    api.reload('04462960', __exports__)
  }
  
  module.hot.accept("./ai-text-box.vue?vue&type=template&id=04462960", () => {
    api.rerender('04462960', render)
  })

}


export default __exports__